//usado para o componente uploadpreviewfield
$(".component_image").each(function () {

    $(this).click(function () {
        $(this).parent().find("input[type=file]").val(null);
        $(this).parent().find("input[type=file]").click();

    });
    $(this).parent().find("input[type=file]").change(function () {
        let reader = new FileReader();
        reader.onload = (e) => {
            getimage($(this)).attr('src', e.target.result);
        }
        reader.readAsDataURL(this.files[0]);

    });
});

//usado para criar um upload dinamico onde a imagem pode ser formatada do jeito que quiser
$('.image_preview').each(function () {

    $(this).change(function () {
        let reader = new FileReader();
        reader.onload = (e) => {
            getimage($(this)).attr('src', e.target.result);
        }
        reader.readAsDataURL(this.files[0]);

    });
});

function getimage(element, maxcheck = 0) {
    if (maxcheck == 4)
        return null;

    console.log(maxcheck);
    maxcheck++;
    if (element.parent().find("img").length == 1)
        return element.parent().find("img");
    else
        return getimage(element.parent(), maxcheck);

}
